import { OneSignal } from 'react-native-onesignal';
import { isWeb } from '../../config/designSystem/Layout';


export const addTrigger = (key: string, value: string) => {
  if(isWeb) {
    return;
  }
  // Never hand OneSignal a null/undefined value: it is a hard Android-only crash.
  // react-native-onesignal's own guard only console.errors and then calls through
  // anyway (dist/index.js: `if (!key || value == null) console.error(...)` with no
  // return), the TurboModule bridge converts JS undefined to Java null, and the
  // OneSignal Android SDK opens addTrigger with a Kotlin
  // `Intrinsics.checkNotNullParameter(value)` -> NullPointerException. iOS accepts
  // nil for an NSString*, so this can only ever be seen on Android.
  // The types say `string`, but callers pass values off the language store through
  // closures, so this is not guaranteed at runtime.
  if (!key || value === null || value === undefined) {
    return;
  }
  OneSignal.InAppMessages.addTrigger(key, value);
};
